// Format a unix timestamp (seconds) as "YYYY-MM-DD HH:MM" in local time.
export function formatTimestamp(seconds: number): string {
  const d = new Date(seconds * 1000);
  const pad = (n: number) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

// Human-readable wait for a rate-limit `retryAfter` (seconds). Rounds up so the
// message never tells someone to retry earlier than the server will accept.
// Returns "しばらく" when the server didn't send a usable number.
export function formatRetryAfter(seconds: unknown): string {
  if (typeof seconds !== "number" || !Number.isFinite(seconds) || seconds <= 0) {
    return "しばらく";
  }
  if (seconds < 60) return `${Math.ceil(seconds)} 秒`;
  if (seconds < 60 * 60) return `${Math.ceil(seconds / 60)} 分`;
  return `${Math.ceil(seconds / 3600)} 時間`;
}
